import React from "react";

const VideoPlayer = ({ videoLink }) => {
  return (
    <div
      style={{
        position: "relative",
        width: "1px",
        minWidth: "100%",
        height: "100%",
      }}
    >
      <iframe
        allow="autoplay"
        allowFullScreen
        lowtransparency="true"
        className="spotlightr"
        frameBorder="0"
        name="videoPlayer"
        scrolling="no"
        src={`${videoLink}?fallback=true`}
        style={{
          position: "absolute",
          width: "1px",
          minWidth: "100%",
          height: "100%",
        }}
      />
    </div>
  );
};

export default VideoPlayer;
